<script>
	import { onMount, onDestroy } from "svelte";
	import Dropzone from "dropzone";

	export let id = "dropzone";
	export let message = "Drop files here or click to upload.";
	export let options = { previewTemplate: "<div/>" };
	export let dropzoneClass = "dropzone";
	export let documentList = [];
	export let disabled = null;

	let myDropzone;

	onMount(() => {
		if (!disabled) {
			Dropzone.autoDiscover = false;
			myDropzone = new Dropzone("div#" + id, options);
			myDropzone.on("addedfile", function (file) {
				file.previewElement.addEventListener("click", function () {
					myDropzone.removeFile(file);
					removeFromFileList({
						fileName: file.name,
						fileSize: formatFileSize(file.size),
						uuid: file.upload.uuid,
						id: "i" + file.upload.uuid.substring(0, 7)
					});
				});
			});
			myDropzone.on("complete", function (file) {
				if (file.status === "success") {
					documentList.push({
						fileName: file.name,
						fileSize: formatFileSize(file.size),
						uuid: file.upload.uuid,
						id: "i" + file.upload.uuid.substring(0, 7)
					});
					documentList = [...documentList];
				}
			});
			repopulateFilePreview();
		}
	});

	$: if (myDropzone && myDropzone.options.url != options.url) {
		myDropzone.options.url = options.url;
		repopulateFilePreview();
	}

	function removeFromFileList(file) {
		for (var i = 0; i < documentList.length; i++) {
			if (documentList[i].uuid == file.uuid) {
				documentList.splice(i, 1);
				documentList = [...documentList];
				break;
			}
		}

		let dropzones = document.querySelectorAll("." + dropzoneClass);
		if (dropzones.length) {
			if (documentList.length == 0) {
				dropzones[0].classList.remove("dz-started");
			} else {
				dropzones[0].classList.add("dz-started");
			}
		}

		var fileElement = document.querySelector("#" + file.id);
		fileElement && fileElement.parentNode.removeChild(fileElement);
	}

	function buildFilePreviewNode(file) {
		let html = `<div id="${file.id}" class="dz-preview dz-file-preview dz-processing dz-success dz-complete" title="Click to delete">
    <div class="dz-image"><img data-dz-thumbnail=""></div>
    <div class="dz-details">
        <div class="dz-size">
            <span data-dz-size="">${file.fileSize}</span>
        </div>
        <div class="dz-filename">
            <span data-dz-name="">${file.fileName}</span>
        </div>
    </div>
</div>`;

		let template = document.createElement("template");
		template.innerHTML = html;
		return template.content.childNodes[0];
	}

	function repopulateFilePreview() {
		let dropzones = document.querySelectorAll("." + dropzoneClass);

		if (!dropzones.length) return;

		let dropzone;

		if (dropzones === null) return;
		if (dropzones.length === 1) {
			dropzone = dropzones[0];
		} else {
			dropzones.forEach((d) => {
				if (d.id == id) dropzone = d;
			});
		}

		if (!dropzone) return;

		let fileNodes = dropzone.querySelectorAll("." + dropzoneClass + " .dz-preview");
		fileNodes.forEach((node) => {
			node.parentNode.removeChild(node);
		});

		if (documentList && documentList.length > 0) {
			dropzone.classList.add("dz-started");
			documentList.forEach((file) => {
				let preview = buildFilePreviewNode(file);

				preview.addEventListener("click", function () {
					myDropzone.removeFile(file);
					removeFromFileList(file);
				});

				dropzone.appendChild(preview);
			});
		} else {
			dropzone.classList.remove("dz-started");
		}
	}

	function formatFileSize(size) {
		var selectedSize = 0;
		var selectedUnit = "b";

		if (size > 0) {
			var units = ["TB", "GB", "MB", "KB", "b"];

			for (var i = 0; i < units.length; i++) {
				var unit = units[i];
				var cutoff = Math.pow(1000, 4 - i) / 10;

				if (size >= cutoff) {
					selectedSize = size / Math.pow(1000, 4 - i);
					selectedUnit = unit;
					break;
				}
			}

			selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
		}

		return "<strong>".concat(selectedSize, "</strong> ").concat(selectedUnit);
	}
</script>

{#if disabled == null}
	<div class="form-row">
		<div class="form-group col-md-12">
			<div class={dropzoneClass} {id}>
				<slot>
					<div class="dz-message needsclick">
						<button type="button" class="dz-button">{message}</button><br />
					</div>
				</slot>
			</div>
		</div>
	</div>
{:else}
	<div class="form-row">
		{#each documentList as document, i}
			<div class="form-group col-md-12">
				{document.fileName}
			</div>
		{/each}
	</div>
{/if}
